import { Grid } from "@mui/material";
import { Fragment } from "react";

import { TextField } from "../../../components";

export default function AudienceSizeForm({ campaign, formikProps, component }) {
  return (
    <Fragment>
      <Grid size={12} style={{ marginTop: "10px" }}>
        <TextField
          label={"Final Audience Parameters"}
          disabled={
            component === "consumer" ||
            campaign.campaignStatus === "LIVE_REQUESTED"
          }
          minRows={5}
          formikProps={formikProps}
          name="audience_params"
          multiline
          onChange={(e) =>
            formikProps.setFieldValue("audience_params", e.target.value)
          }
        />
      </Grid>

      <Grid size={12}>
        <TextField
          label="Total Audience Size"
          disabled={
            component === "consumer" ||
            campaign.campaignStatus === "LIVE_REQUESTED"
          }
          formikProps={formikProps}
          name="audience_size"
        />
      </Grid>

      <Grid size={12}>
        <TextField
          disabled={
            component === "consumer" ||
            campaign.campaignStatus === "LIVE_REQUESTED"
          }
          formikProps={formikProps}
          name="audience_pricing"
          label="Audience Pricing"
        />
      </Grid>
    </Fragment>
  );
}
